<template>
    <div>
      <div v-if="isShow">
        <div v-if="listType==='major'">
          <div class="t_header">{{majorName+'('+majorCode+')'}}</div>
          <ClassTotalTable
              :type="'major'"
              :tableData="totalCount.school"
          ></ClassTotalTable>
          <smallSelect :listType="listType" @change="handleSearch" @export="handleExport"></smallSelect>
          <ClassListTable :type="'major'" :tableData="tableData" @changes="handleChangeClass"></ClassListTable>
          <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
        </div>
        <div v-if="listType==='school'">
          <div class="t_header">{{majorName}}</div>
          <ClassTotalTable
              :type="'school'"
              :tableData="totalCount.school"
          ></ClassTotalTable>
          <smallSelect :listType="listType" @change="handleSearch" @export="handleExport"></smallSelect>
          <ClassListTable :type="'school'" :tableData="tableData"></ClassListTable>
          <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
        </div>
        <div v-if="listType==='company'">
          <div class="t_header">{{majorName}}</div>
          <ClassTotalTable
              :type="'company'"
              :tableData="totalCount.school"
          ></ClassTotalTable>
          <smallSelect :listType="listType" @change="handleSearch" @export="handleExport"></smallSelect>
          <ClassListTable :type="'company'" :tableData="tableData"></ClassListTable>
          <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="handleClick"/>
        </div>
      </div>
      <ClassItemList v-else :listType="listType" :isShows="isShow" :courseItem="courseItem"/>
    </div>
</template>

<script>
import ClassTotalTable from "./ClassTotalTable.vue";
import smallSelect from "./smallSelect.vue";
import ClassListTable from "./ClassListTable.vue";
import pagination from "./Pagination/index.vue";
import ClassItemList from "./classItemList.vue";
import {
    getAlbumTotalCount,
    getAlbumMajorList,
    getMajorAlbumList
} from "@/api/TeachingStatistics";
export default {
    props:{
      majorCode: {type:String,default:''},
      majorName: {type:String,default:''},
      listType: {type:String,default:''}
    },
    components: {
        ClassTotalTable,
        smallSelect,
        ClassListTable,
        pagination,
        ClassItemList
    },
    data() {
        return {
            activeName: "major",
            tableData: [],
            totalCount: {},
            total: 0,
            queryParams:{pageSize:10,pageNum:1},
            tableName:'',
            courseItem:{},
            isShow:true
        };
    },
    methods: {
        // 标签页切换
        async handleClick() {
            const totalCount = await getAlbumTotalCount();
            this.totalCount = totalCount.data.data;
            if (this.listType === "major") {
              const {data} = await getMajorAlbumList({...this.queryParams,majorCode:this.majorCode});
              if(data.code===100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
            if (this.listType === "school") {
              const {data} = await getAlbumMajorList({...this.queryParams,schoolName:this.majorName});
              if(data.code===100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
            if (this.listType === "company") {
              const {data} = await getAlbumMajorList({...this.queryParams,mhmName:this.majorName});
              if(data.code===100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
        },
        /** 搜索/重置事件 */
        async handleSearch(params){
          if (this.listType === "major") {
              const {data} = await getAlbumMajorList({...params,...this.queryParams});
              if(data.code===100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
            if (this.listType === "school") {
              const {data} = await getAlbumMajorList({...params,...this.queryParams,schoolName:this.majorName});
              if(data.code===100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
            if (this.listType === "company") {
              const {data} = await getAlbumMajorList({...params,...this.queryParams,mhmName:this.majorName});
              if(data.code===100000){
                this.tableData = data.data.list;
                this.total = data.data.total;
              }
            }
        },
        /** 选中班级事件 */
        handleChangeClass(row){
          this.courseItem = row;
          if(this.listType === 'major'){
            this.isShow = false;
          }
        },
        /** 导出结果事件 */
        handleExport(row){
          if(this.listType==='major'){
            window.open(
            `${this.url}/zkfz/statistics/albumMajorListExport?courseGroupCode=${row.courseGroupCode}&degreeName=${row.degreeName}&eduLevel=${row.eduLevel}&enrollMajorCode=${row.enrollMajorCode}&mainSchoolCode=${row.mainSchoolCode}&mainSchoolName=${row.mainSchoolName}&majorCode=${row.majorCode}&majorName=${row.majorName}`
              );
          }else if(this.listType==='school'){
            window.open(
            `${this.url}/zkfz/statistics/albumMajorListExport?majorName=${row.majorName}&majorCode=${row.majorCode}&mainSchoolName=${row.mainSchoolName}&degreeName=${row.degreeName}&enrollMajorCode=${row.enrollMajorCode}&courseGroupCode=${row.courseGroupCode}&courseGroupCode=${row.courseGroupCode}&eduLevel=${row.eduLevel}&schoolName=${this.majorName}`
            )
          }else if(this.listType==='company'){
            window.open(
            `${this.url}/zkfz/statistics/albumMajorListExport?majorName=${row.majorName}&majorCode=${row.majorCode}&mainSchoolName=${row.mainSchoolName}&degreeName=${row.degreeName}&enrollMajorCode=${row.enrollMajorCode}&courseGroupCode=${row.courseGroupCode}&courseGroupCode=${row.courseGroupCode}&eduLevel=${row.eduLevel}&mhmName=${this.majorName}`
            )
          }
        }
    },
    mounted() {
        this.handleClick();
    },
    computed: {
      url() {
        let url = window.location.protocol + "//" + window.location.host;
        if (window.location.host == "localhost:5001"  ) {
          url = "http://gz.hnjk.net";
        }
        return url;
      },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    background-color: #64b0ff;
    span {
        color: #fff;
        .num {
            font-size: 24px;
            font-weight: 700;
            color: red;
        }
        .num:hover {
            color: #409eff;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #d7d7d7;
    border: 0;
    span {
        color: #000;
        .num {
            color: red;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    height: 70px;
    padding-top: 30px;
    margin-top: 3px;
}
.t_header{
  background-color: #64b0ff;
  height: 58px;
  // margin: 0 auto;
  text-align: center;
  line-height: 58px;
  color: white;
  margin-top: 2px;
}
</style>